import request, { requestV2 } from 'store/common/utils';
export const getCatalogsApi = () => request({
    url: '/catalogs',
    method: 'GET',
});
export const getCatalogApi = (id) => request({
    url: `/catalogs/${id}`,
    method: 'GET',
});
export const getLastCatalogApi = () => request({
    url: '/catalogs/latest',
    method: 'GET',
});
export const createCatalogApi = (catalog) => request({
    url: '/catalogs',
    method: 'POST',
    data: catalog,
});
export const editCatalogApi = (catalog, signal) => request({
    url: `/catalogs/${catalog.id}`,
    method: 'PUT',
    data: catalog,
    signal,
});
export const publishCatalogApi = (id) => request({
    url: `/catalogs/${id}/publish`,
    method: 'POST',
});
export const generateCatalogApi = (id) => request({
    url: `/catalogs/${id}/generate`,
    method: 'POST',
});
export const addCatalogProjectApi = (catalogId, projectId, signal) => requestV2({
    url: `/catalogs/${catalogId}/projects/${projectId}`,
    method: 'PUT',
    signal,
});
export const removeCatalogProjectApi = (catalogId, projectId, signal) => requestV2({
    url: `/catalogs/${catalogId}/projects/${projectId}`,
    method: 'DELETE',
    signal,
});
export const addCatalogUnitApi = (catalogId, unitId, signal) => requestV2({
    url: `/catalogs/${catalogId}/units/${unitId}`,
    method: 'PUT',
    signal,
});
export const removeCatalogUnitApi = (catalogId, unitId, signal) => requestV2({
    url: `/catalogs/${catalogId}/units/${unitId}`,
    method: 'DELETE',
    signal,
});
export const getAdminPreviewCatalogApi = ({ projectId, locale = 'en', theme = 'light', }) => requestV2({
    url: `/projects/${projectId}/catalog-preview?locale=${locale}&theme=${theme}`,
    method: 'GET',
    headers: { 'x-api-scope': 'admin' },
});
